import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Empty } from '../../empty';
import { ResponseList } from '../../response-list';
import { OperationSectionBody } from './OperationSectionBody';
import { OperationSectionHeading } from './OperationSectionHeading';
export function OperationResponsesSection({ operation }) {
    const { responses = {} } = operation;
    const responsesWithStatusCode = Object.entries(responses).filter(([statusCode, _]) => !statusCode.startsWith('x-'));
    return (_jsxs(_Fragment, { children: [_jsx(OperationSectionHeading, { children: "Returns" }), _jsxs(OperationSectionBody, { children: [responsesWithStatusCode.length === 0 && _jsx(Empty, { children: "No return value." }), responsesWithStatusCode.length > 0 && (_jsx(ResponseList, { responses: Object.fromEntries(responsesWithStatusCode) }))] })] }));
}
